export enum Event {
  ceScreenTime = 'ce-screen-time',
  ceLoginSuccess = 'ce-login-success',
  iisBtnPayHere = 'iis-btn-pay-here',
  iisBtnViewMore = 'iis-btn-view-more',
  iidsBtnContactExecutive = 'iids-btn-contact-executive',
  iidsBtnSendContactExecutive = 'iids-btn-send-contact-executive',
  iidsBtnDwPolicy = 'iids-btn-dw-policy',
  iidsAccShowContractor = 'iids-acc-show-contractor',
  iidsAccShowInsured = 'iids-acc-show-insured',
  iidsAccShowBeneficiaries = 'iids-acc-show-beneficiaries',
  iidsBtnShowCartola = 'iids-btn-show-cartola',
  iidsBtnModifyData = 'iids-btn-modify-data',
  iidsBtnSaveModifyData = 'iids-btn-save-modify-data',
  iidsBtnModifyBeneficiary = 'iids-btn-modify-beneficiary',
  iidsBtnAddBeneficiary = 'iids-btn-add-beneficiary',
  iidsBtnRemoveBeneficiary = 'iids-btn-remove-beneficiary',
  iidsBtnRequestBeneficiary = 'iids-btn-request-beneficiary',
  iidsIcDetailBeneficiary = 'iids-ic-detail-beneficiary',
  iidsBtnEditBeneficiary = 'iids-btn-edit-beneficiary',
  iidbBtnSaveComplaint = 'iidb-btn-save-complaint',
  iidbAccShowReport = 'iidb-acc-show-report',
  iidbAccShowBenefitsPaid = 'iidb-acc-show-benefits-paid',
  iideBtnTypeEndorsement = 'iide-btn-type-endorsement',
  iideBtnRequestEndorsement = 'iide-btn-request-endorsement',
  iideBtnAddBeneficiary = 'iide-btn-add-beneficiary',
  iideBtnRequestBeneficiary = 'iide-btn-request-beneficiary',
  iideBtnRemoveBeneficiary = 'iide-btn-remove-beneficiary',
  iidpBtnPayStepper = 'iidp-btn-pay-stepper',
  iidpBtnPayConfirm = 'iidp-btn-pay-confirm',
  iidpBtnPaySpecificAmount = 'iidp-btn-pay-specific-amount',
  iidoRadioChangePeriod = 'iido-radio-change-period',
  iidoIcOpenMonthly = 'iido-ic-open-monthly',
  iidoIcOpenAnnual = 'iido-ic-open-annual',
  iidoIcOpenCertificate = 'iido-ic-open-certificate',
  iidoIcDownloadFile = 'iido-ic-download-file',
  iidoLkShowDetail = 'iido-lk-show-detail',
  iidoAccShowMovements = 'iido-acc-show-movements',
  iidoAccShowBalanceAccount = 'iido-acc-show-balance-account',
  iidoAccShowBalancePeriodAmount = 'iido-acc-show-balance-period-amount',
  iidoAccShowProfitability = 'iido-acc-show-profitability',
  iidoAccShowBalanceAccountAmount = 'iido-acc-show-balance-account-amount',
  iidoAccShowMovementsDate = 'iido-acc-show-movements-date',
  iidtBtnNewDistribution = 'iidt-btn-new-distribution',
  iidtBtnAddAlternative = 'iidt-btn-add-alternative',
  iidtBtnConfirmTransfer = 'iidt-btn-confirm-transfer',
  iidtBtnRetryTransfer = 'iidt-btn-retry-transfer',
  iidtBtnConfirmCancellation = 'iidt-btn-confirm-cancellation',
  iidefBtnSearchEffectiveness = 'iidef-btn-search-effectiveness',
  iidefIcDownloadFile = 'iidef-ic-download-file',
  iidefAccShowAll = 'iidef-acc-show-all',
  iidefAccShowProfitability = 'iidef-acc-show-profitability',
  iidqBtnSearchQuota = 'iidq-btn-search-quota',
  iidqIcDownloadFile = 'iidq-ic-download-file',
  iidrBtnRequestRescue = 'iidr-btn-request-rescue',
  iidrInitRescue = 'iidr-init-rescue',
  iidrBtnCompleteStep1Rescue = 'iidr-btn-continue-step1-rescue',
  iidrBtnCompleteStep2Rescue = 'iidr-btn-continue-step2-rescue',
  iidrCompleteRescueFinal = 'iidr-complete-rescue',
  iidrRescueError = 'iidr-rescue-error',
  iidrBtnCancelRescue = 'iidr-btn-cancel-rescue',
  iidrBtnConfirmCancelRescue = 'iidr-btn-confirm-cancel-rescue',
  iidhAccShowPaid = 'iidh-acc-show-paid',
  iidhAccShowProvided = 'iidh-acc-show-provided',
  pisBtnViewMore = 'pis-btn-view-more',
  pidsBtnModifyData = 'pids-btn-modify-data',
  pidsBtnSaveModifyData = 'pids-btn-save-modify-data',
  pidsBtnRequestCertificate = 'pids-btn-request-certificate',
  pidsIcShowDetailBeneficiary = 'pids-ic-show-detail-beneficiary',
  pidsAccShowRentier = 'pids-acc-show-rentier',
  pidsAccShowContractor = 'pids-acc-show-contractor',
  pidsAccShowBeneficiaries = 'pids-acc-show-beneficiaries',
  pidlBtnSearchLiquidation = 'pidl-btn-search-liquidation',
  pidlIcShowDetailLiquidation = 'pidl-ic-show-detail-liquidation',
  pidlBtnDownloadLiquidation = 'pidl-btn-download-liquidation',
  pidlAccShowLiquidation = 'pidl-acc-show-liquidation',
  lisBtnViewMore = 'lis-btn-view-more',
  lidsBtnModifyData = 'lids-btn-modify-data',
  lidsBtnSaveModifyData = 'lids-btn-save-modify-data',
  lidsBtnModifyDataPm = 'lids-btn-modify-data-pm',
  lidsBtnSaveModifyDataPm = 'lids-btn-save-modify-data-pm',
  lidsIcShowDetailBeneficiary = 'lids-ic-show-detail-beneficiary',
  lidsAccShowRentier = 'lids-acc-show-rentier',
  lidsAccShowWayToPay = 'lids-acc-show-way-to-pay',
  lidsAccShowBeneficiaries = 'lids-acc-show-beneficiaries',
  lidlBtnSearchLiquidation = 'lidl-btn-search-liquidation',
  lidlIcShowDetailLiquidation = 'lidl-ic-show-detail-liquidation',
  lidlBtnDownloadLiquidation = 'lidl-btn-download-liquidation',
  lidlAccShowLiquidation = 'lidl-acc-show-liquidation',
  lidpBtnGenerateCartola = 'lidp-btn-generate-cartola',
  lidcBtnSearchCertificate = 'lidc-btn-search-certificate',
  lidcBtnRequestCertificate = 'lidc-btn-request-certificate',
  gisBtnViewMore = 'gis-btn-view-more',
  gisBtnRequestRefund = 'gis-btn-request-refund',
  gisBtnShowDetailPlan = 'gis-btn-show-detail-plan',
  gidsBtnModifyData = 'gids-btn-modify-data',
  gidsBtnSaveModifyData = 'gids-btn-save-modify-data',
  gidsBtnEditBenefiary = 'gids-btn-edit-benefiary',
  gidsBtnRemoveBenefiary = 'gids-btn-remove-benefiary',
  gidsBtnAddBenefiary = 'gids-btn-add-benefiary',
  gidsBtnSaveModifyBeneficiary = 'gids-btn-save-modify-beneficiary',
  gidsBtnModifyBeneficiaries = 'gids-btn-modify-beneficiaries',
  gidsIcDownloadCertificate = 'gids-ic-download-certificate',
  gidsAccShowInsured = 'gids-acc-show-insured',
  gidsAccShowFamilyGroup = 'gids-acc-show-family-group',
  giddAccShowDetailPlan = 'gidd-acc-show-detail-plan',
  gidsAccShowBenificiaries = 'gids-acc-show-benificiaries',
  gidsAccShowCertificate = 'gids-acc-show-certificate',
  gidfIcDownloadForm = 'gidf-ic-download-form',
  gidrBtnRequestRefund = 'gidr-btn-request-refund',
  gidrIcShowDetailLiquidation = 'gidr-ic-show-detail-liquidation',
  gidrIcDownloadBeneficiary = 'gidr-ic-download-beneficiary',
  gidrIcDownloadLiquidation = 'gidr-ic-download-liquidation',
  gidrAccShowRequestRefunds = 'gidr-acc-show-request-refunds',
  icPayMyProducts = 'ic-pay-my-products',
  accShowProduct = 'acc-show-product',
  btnPayProduct = 'btn-pay-product',
  btnMyData = 'btn-my-data',
  btnChangePassword = 'btn-change-password',
  btnSavePassword = 'btn-save-password',
  btnSelectInsured = 'btn-select-insured',
  lkSelectPolicy = 'lk-select-policy',
  lkBannerOncological = 'lk-banner-oncological',
  lkBannerClubViva = 'lk-banner-club-viva',
  lkBannerChanchito = 'lk-banner-chanchito',
  btnProfitabilityReport = 'btn-profitability-report',
  btnDownloadProfitability = 'btn-download-profitability',
  btnGoPaymentMethods= 'btn-go-payments-methods',
  btnRetiroTotal= 'btn-retiro-total',
  btnRetiroParcial= 'btn-retiro-parcial',
  btnAcceptTerms = 'btn-accept-terms',
  btnRejactedTerms = 'btn-rejacted-terms',
  btnGoWithdrawalConfirm = 'btn-withdrawal-confirm',
  btnDownloadWithdrawalVoucher = 'btn-download-withdrawal-voucher', 
  btnDownloadCancelVoucher = 'btn-download-cancel-voucher',
  btnAcceptTermsCV = 'btn-accept-terms-cv',
  lkLoadReembolso = 'lk-load-reembolso',
  btnWithdrawalConfirm = 'btn-withdrawal-confirms',
  withdrawalSuccess = "withdrawal-success",
  withdrawalCancelSuccess = "withdrawal-cancel-success",
  withdrawalError = "withdrawal-error",
  btnSaludVidaSolicitarReembolso = 'btn-saludvida-solicitar-reembolso',
  reembolsoSaludVidaSuccess = 'reembolso-salud-vida-success',
  reembolsoSaludVidaFailed = 'reembolso-salud-vida-Failed',
  reembolsoSaludVidaEnviado = 'reembolso-salud-vida-enviado',
  sitioPrivadoAhorroRentabilidad = 'sitio_privado_ahorro_rentabilidad',
  sitioPrivadoAhorroValorCuota = 'sitio_privado_ahorro_valor_cuota',
}

export const getValueEvent: { [key in Event]: string } = {
  [Event.ceScreenTime]: 'Tiempo en pantalla',
  [Event.ceLoginSuccess]: 'Inicio de sesión exitoso',
  [Event.iisBtnPayHere]: 'Seguro Individual - Pagar Aquí Póliza',
  [Event.iisBtnViewMore]: 'Seguro Individual - Ver Detalle Póliza',
  [Event.iidsBtnContactExecutive]: 'Seguro Individual - Contactar Ejecutivo',
  [Event.iidsBtnSendContactExecutive]:
    'Seguro Individual - Enviar Contactar Ejecutivo',
  [Event.iidsBtnDwPolicy]: 'Seguro Individual - Resumen Descargar Póliza',
  [Event.iidsAccShowContractor]:
    'Seguro Individual - Resumen Desplegar Datos del Contratante',
  [Event.iidsAccShowInsured]:
    'Seguro Individual - Resumen Desplegar Asegurados',
  [Event.iidsAccShowBeneficiaries]:
    'Seguro Individual - Resumen Desplegar Beneficiarios',
  [Event.iidsBtnShowCartola]: 'Seguro Individual - Resumen Ver Cartola',
  [Event.iidsBtnModifyData]:
    'Seguro Individual - Datos del Contratante Modificar Datos',
  [Event.iidsBtnSaveModifyData]:
    'Seguro Individual - Datos del Contratante Guardar Datos',
  [Event.iidsBtnModifyBeneficiary]:
    'Seguro Individual - Modificar Beneficiario',
  [Event.iidsBtnAddBeneficiary]: 'Seguro Individual - Agregar Beneficiario',
  [Event.iidsBtnRemoveBeneficiary]: 'Seguro Individual - Eliminar Beneficiario',
  [Event.iidsBtnRequestBeneficiary]:
    'Seguro Individual - Solicitar Beneficiario',
  [Event.iidsIcDetailBeneficiary]: 'Seguro Individual - Detalle Beneficiario',
  [Event.iidsBtnEditBeneficiary]: 'Seguro Individual - Guardar Beneficiario',
  [Event.iidbBtnSaveComplaint]: 'Seguro Individual - Solicitar Denuncia',
  [Event.iidbAccShowReport]:
    'Seguro Individual - Desplegar Denuncia tu Siniestro',
  [Event.iidbAccShowBenefitsPaid]:
    'Seguro Individual - Desplegar Beneficios Pagados',
  [Event.iideBtnTypeEndorsement]:
    'Seguro Individual - Solicitar Endoso por tipo',
  [Event.iideBtnRequestEndorsement]:
    'Seguro Individual - Confirmar Solicitar Endoso',
  [Event.iideBtnAddBeneficiary]:
    'Seguro Individual - Agregar Beneficiario desde Endoso',
  [Event.iideBtnRequestBeneficiary]:
    'Seguro Individual - Solicitar Beneficiario desde Endoso',
  [Event.iideBtnRemoveBeneficiary]:
    'Seguro Individual - Eliminar Beneficiario desde Endoso',
  [Event.iidpBtnPayStepper]:
    'Seguro Individual - Pagar y abrir el Carro de Pagos',
  [Event.iidpBtnPayConfirm]: 'Seguro Individual - Confirmar Pago',
  [Event.iidpBtnPaySpecificAmount]: 'Seguro Individual - Abonar Pago',
  [Event.iidoRadioChangePeriod]: 'Seguro Individual - Cambiar Período',
  [Event.iidoIcOpenMonthly]: 'Seguro Individual - Descarga Cartola Mensual',
  [Event.iidoIcOpenAnnual]: 'Seguro Individual - Descarga Cartola Anual',
  [Event.iidoIcOpenCertificate]:
    'Seguro Individual - Descarga Cartola Certificados',
  [Event.iidoIcDownloadFile]: 'Seguro Individual - Descargar Cartola',
  [Event.iidoLkShowDetail]: 'Seguro Individual - Detalle Utilidad',
  [Event.iidoAccShowMovements]:
    'Seguro Individual - Desplegar Resumen de Movimientos',
  [Event.iidoAccShowBalanceAccount]:
    'Seguro Individual - Desplegar Saldo por Cuenta',
  [Event.iidoAccShowBalancePeriodAmount]:
    'Seguro Individual - Desplegar Resumen Saldo por Período Monto',
  [Event.iidoAccShowProfitability]:
    'Seguro Individual - Desplegar Resumen Saldo por Alternativas de Rentabilidad',
  [Event.iidoAccShowBalanceAccountAmount]:
    'Seguro Individual - Desplegar Resumen Saldo por Cuenta Monto',
  [Event.iidoAccShowMovementsDate]:
    'Seguro Individual - Desplegar Movimientros entre (Fechas)',
  [Event.iidtBtnNewDistribution]:
    'Seguro Individual - Abrir Nueva Distribución',
  [Event.iidtBtnAddAlternative]:
    'Seguro Individual - Agregar Alternativa - Nueva Distribución',
  [Event.iidtBtnConfirmTransfer]:
    'Seguro Individual - Confirmar Traslado - Nueva Distribución',
  [Event.iidtBtnRetryTransfer]:
    'Seguro Individual - Reintentar - Nueva Distribución',
  [Event.iidtBtnConfirmCancellation]: 'Seguro Individual - Confirmar Anulación',
  [Event.iidefBtnSearchEffectiveness]:
    'Seguro Individual - Buscar Rentabilidad',
  [Event.iidefIcDownloadFile]:
    'Seguro Individual - Descargar Ficha de Rentabilidad',
  [Event.iidefAccShowAll]:
    'Seguro Individual - Desplegar Todos (rentabilidades)',
  [Event.iidefAccShowProfitability]:
    'Seguro Individual - Desplegar Rentabilidad (detalle)',
  [Event.iidqBtnSearchQuota]: 'Seguro Individual - Buscar Valores Cuota',
  [Event.iidqIcDownloadFile]: 'Seguro Individual - Descargar Cuota',
  [Event.iidrBtnRequestRescue]: 'Seguro Individual - Solicitud de rescate',
  [Event.iidrInitRescue]: 'Seguro Individual - Rescate iniciado',
  [Event.iidrBtnCompleteStep1Rescue]: 'Seguro Individual - Primer paso rescate',
  [Event.iidrBtnCompleteStep2Rescue]:
    'Seguro Individual - Segundo paso rescate',
  [Event.iidrCompleteRescueFinal]: 'Seguro Individual - Completar rescate',
  [Event.iidrRescueError]: 'Seguro Individual - Error en rescate',
  [Event.iidrBtnCancelRescue]: 'Seguro Individual - Cancelar rescate',
  [Event.iidrBtnConfirmCancelRescue]:
    'Seguro Individual - Confirmar Cancelar rescate',
  [Event.iidhAccShowPaid]:
    'Seguro Individual - Acordion Primas Periódicas Pagadas',
  [Event.iidhAccShowProvided]:
    'Seguro Individual - Acordion Primas Esporádicas Aportadas',
  [Event.pisBtnViewMore]: 'Seguro Privado - Ver Detalle Póliza',
  [Event.pidsBtnModifyData]: 'Seguro Privado - Resumen Modificar Datos',
  [Event.pidsBtnSaveModifyData]: 'Seguro Privado -  Resumen Guardar Datos',
  [Event.pidsBtnRequestCertificate]:
    'Seguro Privado - Solicitar Certificado de Liquidación',
  [Event.pidsIcShowDetailBeneficiary]:
    'Seguro Privado - Ver Detalle Beneficiario',
  [Event.pidsAccShowRentier]: 'Seguro Privado - Desplegar Datos del Rentista',
  [Event.pidsAccShowContractor]:
    'Seguro Privado - Desplegar Datos del Contratante',
  [Event.pidsAccShowBeneficiaries]: 'Seguro Privado - Desplegar Beneficiarios',
  [Event.pidlBtnSearchLiquidation]: 'Seguro Privado - Buscar Liquidaciones',
  [Event.pidlIcShowDetailLiquidation]:
    'Seguro Privado - Ver Detalle Liquidación',
  [Event.pidlBtnDownloadLiquidation]: 'Seguro Privado - Descargar Liquidación',
  [Event.pidlAccShowLiquidation]:
    'Seguro Privado - Desplegar Liquidaciones (por año)',
  [Event.lisBtnViewMore]: 'Seguro Vitalicio - Ver Detalle Póliza',
  [Event.lidsBtnModifyData]: 'Seguro Vitalicio - Resumen Modificar Datos',
  [Event.lidsBtnSaveModifyData]: 'Seguro Vitalicio - Resumen Guardar Datos',
  [Event.lidsBtnModifyDataPm]:
    'Seguro Vitalicio - Forma de Pago Modificar Datos ',
  [Event.lidsBtnSaveModifyDataPm]:
    'Seguro Vitalicio - Forma de Pago Guardar Datos',
  [Event.lidsIcShowDetailBeneficiary]:
    'Seguro Vitalicio - Ver Detalle Beneficiario',
  [Event.lidsAccShowRentier]: 'Seguro Vitalicio - Desplegar Datos del Rentista',
  [Event.lidsAccShowWayToPay]: 'Seguro Vitalicio - Desplegar Forma de Pago',
  [Event.lidsAccShowBeneficiaries]:
    'Seguro Vitalicio - Desplegar Beneficiarios',
  [Event.lidlBtnSearchLiquidation]: 'Seguro Vitalicio - Buscar Liquidaciones',
  [Event.lidlIcShowDetailLiquidation]:
    'Seguro Vitalicio - Ver Detalle Liquidación',
  [Event.lidlBtnDownloadLiquidation]: 'Seguro Vitalicio - DescargarLiquidación',
  [Event.lidlAccShowLiquidation]:
    'Seguro Vitalicio - Desplegar Liquidaciones (por año)',
  [Event.lidpBtnGenerateCartola]: 'Seguro Vitalicio - Generar Cartola',
  [Event.lidcBtnSearchCertificate]: 'Seguro Vitalicio - Buscar Certificado',
  [Event.lidcBtnRequestCertificate]:
    'Seguro Vitalicio - Ver Detalle Certificado',
  [Event.gisBtnViewMore]: 'Seguro Colectivo - Ver Detalle Póliza',
  [Event.gisBtnRequestRefund]: 'Seguro Colectivo - Solicitar Reembolso',
  [Event.gisBtnShowDetailPlan]: 'Seguro Colectivo - Ver Detalle de Mi Plan',
  [Event.gidsBtnModifyData]: 'Seguro Colectivo - Resumen Modificar Datos',
  [Event.gidsBtnSaveModifyData]: 'Seguro Colectivo - Resumen Guardar Datos',
  [Event.gidsBtnEditBenefiary]: 'Seguro Colectivo - Editar Beneficiario',
  [Event.gidsBtnRemoveBenefiary]: 'Seguro Colectivo - Eliminar Beneficiario',
  [Event.gidsBtnAddBenefiary]: 'Seguro Colectivo - Agregar Beneficiario',
  [Event.gidsBtnSaveModifyBeneficiary]:
    'Seguro Colectivo - Guardar Modificación del Beneficiario',
  [Event.gidsBtnModifyBeneficiaries]:
    'Seguro Colectivo - Modificar Beneficiarios',
  [Event.gidsIcDownloadCertificate]: 'Seguro Colectivo - Descargar Certificado',
  [Event.gidsAccShowInsured]: 'Seguro Colectivo - Desplegar Asegurado',
  [Event.gidsAccShowFamilyGroup]: 'Seguro Colectivo - Desplegar Grupo Familiar',
  [Event.giddAccShowDetailPlan]: 'Seguro Colectivo - Desplegar Mostrar Plan',
  [Event.gidsAccShowBenificiaries]:
    'Seguro Colectivo - Desplegar Beneficiarios Seguro de Vida',
  [Event.gidsAccShowCertificate]: 'Seguro Colectivo - Desplegar Certificados',
  [Event.gidfIcDownloadForm]: 'Seguro Colectivo - Descargar Formulario',
  [Event.gidrBtnRequestRefund]: 'Seguro Colectivo - Solicitar Reembolso',
  [Event.gidrIcShowDetailLiquidation]:
    'Seguro Colectivo - Ver Detalle Liquidación',
  [Event.gidrIcDownloadBeneficiary]:
    'Seguro Colectivo - Descargar Beneificiario',
  [Event.gidrIcDownloadLiquidation]: 'Seguro Colectivo - Descargar Liquidación',
  [Event.gidrAccShowRequestRefunds]:
    'Seguro Colectivo - Desplegar Solicitudes de Reembolso',
  [Event.icPayMyProducts]: 'Pagar mis Productos',
  [Event.accShowProduct]: 'Desplegar Nombre de Producto',
  [Event.btnPayProduct]: 'Abonar Producto',
  [Event.btnMyData]: 'Mis Datos',
  [Event.btnChangePassword]: 'Cambiar Contraseña',
  [Event.btnSavePassword]: 'Guardar Contraseña',
  [Event.btnSelectInsured]: 'Tipo de Seguro',
  [Event.lkSelectPolicy]: 'Seleccionar Póliza',
  [Event.lkBannerOncological]: 'Banner Oncológico',
  [Event.lkLoadReembolso]: 'Web Onclick Salud',
  [Event.lkBannerClubViva]: 'Banner Club Viva',
  [Event.lkBannerChanchito]: 'Banner Chanchito',
  [Event.btnProfitabilityReport]: 'Informe de Rentabilidad',
  [Event.btnDownloadProfitability]: 'Descargar PDF de Rentabilidad',
  [Event.btnGoPaymentMethods]: 'Avanzar al step de metodo de pago', 
  [Event.btnRetiroTotal]: 'Seleccionar retiro total',
  [Event.btnRetiroParcial]: 'Seleccionar retiro parcial',
  [Event.btnAcceptTerms]: 'Aceptar terminos y condiciones de un rescate total',
  [Event.btnRejactedTerms]: 'Rechazar terminos y condiciones de un rescate total',
  [Event.btnGoWithdrawalConfirm]: 'Avanzar al step de confirmacion de rescate',
  [Event.btnWithdrawalConfirm]: 'Confirmar solicitud de rescate',
  [Event.btnDownloadWithdrawalVoucher]: 'Descargar comprobante de recate',
  [Event.btnDownloadCancelVoucher]: 'Descargar comprobante de cancelacion de rescate',
  [Event.btnAcceptTermsCV]: 'Aceptar terminos para cuentas de cotizacion voluntarias',
  [Event.withdrawalSuccess]: 'Mensaje entregado al cliente en un rescate exitoso',
  [Event.withdrawalError]: 'Mensaje entregado al cliente al ocurrir un error en el rescate',
  [Event.withdrawalCancelSuccess]: 'Mensaje entregado al cliente al cancelar exitosamente un rescate',
  [Event.btnSaludVidaSolicitarReembolso]: 'Enviar solicitud de reembolso salud vida',
  [Event.reembolsoSaludVidaSuccess]: 'Reembolso salud vida cursado con exito',
  [Event.reembolsoSaludVidaFailed]: 'Reembolso salud vida fallido',
  [Event.reembolsoSaludVidaEnviado]: 'Data reembolso enviado salud vida',
  [Event.sitioPrivadoAhorroRentabilidad]: 'Sitio Privado - Ahorro Rentabilidad',
  [Event.sitioPrivadoAhorroValorCuota]: 'Sitio Privado - Ahorro Valor Cuota',
};
